module.exports = __webpack_public_path__ + "img/serial-number.697f2fee.svg";